import getBuildConfigCustomRow from "../DataDisplayRow/BuildConfigCustomRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";

class BuildConfigCustomRowTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getBuildConfigCustomRow()
    }
}

let buildConfigCustomRowTable: BuildConfigCustomRowTable | null = null;

export default function getBuildConfigCustomTable(): BuildConfigCustomRowTable {
    if (buildConfigCustomRowTable === null)
        buildConfigCustomRowTable = new BuildConfigCustomRowTable()
    return buildConfigCustomRowTable
}